// =========================================================
// Vojjin Tooltip Utilities
// =========================================================
import {registerGlobal} from "./core.js";

class Tooltip {

    constructor({ selector = '[data-tooltip]', offset = 8, timeout = 0 } = {}) {
        this.selector = selector;
        this.offset = offset;
        this.timeout = timeout; // 🕒 store default timeout (ms)
        this.activeTooltip = null;
        this.hideTimer = null;

        this.boundShow = this.showTooltip.bind(this);
        this.boundHide = this.hideTooltip.bind(this);
        this.boundCleanup = this.removeTooltip.bind(this);

        this.bindEvents();
    }

    bindEvents() {
        document.addEventListener('mouseover', this.boundShow);
        document.addEventListener('mouseout', this.boundHide);
        window.addEventListener('scroll', this.boundCleanup);
        window.addEventListener('resize', this.boundCleanup);
    }

    showTooltip(e) {
        const target = e.target.closest(this.selector);
        if (!target) return;

        const content = target.dataset.tooltip;
        if (!content) return;

        const allowHtml =
            typeof target.dataset.tooltipHtml !== "undefined"
                ? target.dataset.tooltipHtml === "true"
                : false;
        const pos = target.dataset.tooltipPosition || "left";
        const classa = target.dataset.tooltipClass || "";

        // 🧹 remove previous tooltip + clear timer
        this.removeTooltip();

        const tooltip = document.createElement("div");
        tooltip.className = "tooltip-element" + (classa ? " " + classa : "");
        tooltip.dataset.pos = pos;

        if (allowHtml) tooltip.innerHTML = content;
        else tooltip.textContent = content;

        document.body.appendChild(tooltip);
        this.activeTooltip = tooltip;

        // 🧭 position
        const rect = target.getBoundingClientRect();
        const tipRect = tooltip.getBoundingClientRect();
        const offset = this.offset;
        let top, left;

        switch (pos) {
            case "bottom":
                top = rect.bottom + offset + window.scrollY;
                left = rect.left + rect.width / 2 - tipRect.width / 2 + window.scrollX;
                break;
            case "left":
                top = rect.top + rect.height / 2 - tipRect.height / 2 + window.scrollY;
                left = rect.left - tipRect.width - offset + window.scrollX;
                break;
            case "right":
                top = rect.top + rect.height / 2 - tipRect.height / 2 + window.scrollY;
                left = rect.right + offset + window.scrollX;
                break;
            default:
                top = rect.top - tipRect.height - offset + window.scrollY;
                left = rect.left + rect.width / 2 - tipRect.width / 2 + window.scrollX;
        }

        tooltip.style.top = `${top}px`;
        tooltip.style.left = `${left}px`;

        requestAnimationFrame(() => tooltip.classList.add("show"));

        // 🕒 Start timeout if configured
        if (this.timeout > 0) {
            this.hideTimer = setTimeout(() => {
                this.removeTooltip();
            }, this.timeout);
        }
    }

    hideTooltip(e) {
        const target = e.target.closest(this.selector);
        if (!target) return;
        this.removeTooltip();
    }

    removeTooltip() {
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
            this.hideTimer = null;
        }
        if (this.activeTooltip) {
            this.activeTooltip.remove();
            this.activeTooltip = null;
        }
    }

    destroy() {
        document.removeEventListener("mouseover", this.boundShow);
        document.removeEventListener("mouseout", this.boundHide);
        window.removeEventListener("scroll", this.boundCleanup);
        window.removeEventListener("resize", this.boundCleanup);
        this.removeTooltip();
    }
}

registerGlobal("Tooltip", Tooltip);